import React from "react";
import {
  Typography,
  Button,
  Avatar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import API from "../API";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import { DateRangePicker, LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { SingleInputDateRangeField } from "@mui/x-date-pickers-pro/SingleInputDateRangeField";

const NAMES = [
  "Motorsiklet",
  "Sedan",
  "Doblo",
  "Minivan",
  "Panelvan",
  "Kamyonet",
];

const shortcutsItems = [
  {
    label: "Bugün",
    getValue: () => {
      const today = dayjs();
      return [today.startOf("day"), today.endOf("day")];
    },
  },
  {
    label: "Bu Hafta",
    getValue: () => {
      const today = dayjs();
      return [today.startOf("week"), today.endOf("week")];
    },
  },
  {
    label: "Geçen Hafta",
    getValue: () => {
      const today = dayjs();
      const prevWeek = today.subtract(7, "day");
      return [prevWeek.startOf("week"), prevWeek.endOf("week")];
    },
  },
  {
    label: "Son 7 Gün",
    getValue: () => {
      const today = dayjs();
      return [today.subtract(7, "day"), today];
    },
  },
  {
    label: "Bu Ay",
    getValue: () => {
      const today = dayjs();
      return [today.startOf("month"), today.endOf("month")];
    },
  },
  { label: "Her zaman", getValue: () => [null, null] },
];

export default class ApplicationsScreen extends React.Component {
  constructor() {
    super();
    this.state = {
      rows: [],
      selectedCity: "", // "" = all cities
    };

    this._idFilter = null;
    this.dateFilter = null;
  }

  componentDidMount() {
    API.fetch("getapplications").then((e) => {
      if (!e.error) {
        this.allRows = e.map((x, i) => {
          const createdDate = dateFromObjectId(x._id);
          const createdDateString = createdDate.toLocaleString("tr-TR");

          const isCompleted = x.submitDate && x.status == 1;
          const completeTimestamp = isCompleted ? x.submitDate : 0;
          const completeDateString = isCompleted
            ? new Date(x.submitDate).toLocaleString("tr-TR")
            : "";

          return {
            id: i,
            "AD SOYAD": x,
            TARİH: createdDate,
            dateString: createdDateString,
            "TAMAMLAMA TARİHİ": completeTimestamp,
            completeDate: completeDateString,
            DURUM: x.status,
            NOT: x.note,
            TELEFON: x.tel,
            ŞEHİR: API.getCityName(x.city),
            cityId: x.city, // 👈 used for filtering
            tFile: x.tFile,
            lFile: x.lFile,
            ARAÇ: NAMES[x.type],
          };
        });

        this.setState({ rows: this.allRows });
      }
    });
  }

  refreshCurrentFilters() {
    const { selectedCity } = this.state;

    this.setState({
      rows: this.allRows.filter((s) => {
        if (
          this._idFilter &&
          (s["TARİH"] < this._idFilter.$gte || s["TARİH"] > this._idFilter.$lte)
        )
          return false;

        if (
          this.dateFilter &&
          (s["TAMAMLAMA TARİHİ"] < this.dateFilter.$gte ||
            s["TAMAMLAMA TARİHİ"] > this.dateFilter.$lte)
        )
          return false;

      
        if (selectedCity && String(s.cityId) !== String(selectedCity))
          return false;

        return true;
      }),
    });
    this.forceUpdate();
  }

  render() {
    return (
      <div>
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div>
              <p>Oluşturma Tarihi</p>
              <DateRangePicker
                onAccept={(range) => {
                  if (
                    (range[0] == null && range[1] == null) ||
                    (range[0] != null && range[1] != null)
                  ) {
                    if (range[0] != null) {
                      const firstRange = new Date(range[0].$d);
                      firstRange.setHours(0, 0, 0);

                      const secRange = new Date(range[1].$d);
                      secRange.setHours(23, 59, 59);

                      this._idFilter = {
                        $gte: firstRange.getTime(),
                        $lte: secRange.getTime(),
                      };
                    } else {
                      this._idFilter = null;
                    }

                    this.refreshCurrentFilters();
                  }
                }}
                slotProps={{
                  shortcuts: { items: shortcutsItems },
                  actionBar: { actions: [] },
                }}
                slots={{ field: SingleInputDateRangeField }}
                localeText={{ start: "Check-in", end: "Check-out" }}
              />
            </div>

            <div>
              <p>Tamamlama Tarihi</p>
              <DateRangePicker
                onAccept={(range) => {
                  if (
                    (range[0] == null && range[1] == null) ||
                    (range[0] != null && range[1] != null)
                  ) {
                    if (range[0] != null) {
                      const firstRange = new Date(range[0].$d);
                      firstRange.setHours(0, 0, 0);

                      const secRange = new Date(range[1].$d);
                      secRange.setHours(23, 59, 59);

                      this.dateFilter = {
                        $gte: firstRange.getTime(),
                        $lte: secRange.getTime(),
                      };
                    } else {
                      this.dateFilter = null;
                    }

                    this.refreshCurrentFilters();
                  }
                }}
                slotProps={{
                  shortcuts: { items: shortcutsItems },
                  actionBar: { actions: [] },
                }}
                slots={{ field: SingleInputDateRangeField }}
                localeText={{ start: "Check-in", end: "Check-out" }}
              />
            </div>
          </LocalizationProvider>

          {/* Şehir filtresi */}
          <div>
            <p>Şehir</p>
            <FormControl size="large" style={{ minWidth: 200 }}>
              <InputLabel id="city-filter-label">Şehir</InputLabel>
              <Select
                labelId="city-filter-label"
                label="Şehir"
                value={this.state.selectedCity}
                onChange={(e) => {
                  this.setState({ selectedCity: e.target.value }, () =>
                    this.refreshCurrentFilters()
                  );
                }}
              >
                <MenuItem value="">
                  <em>Tüm Şehirler</em>
                </MenuItem>
                {Object.keys(API.allowedCities || {}).map((cityId) => (
                  <MenuItem key={cityId} value={cityId}>
                    {API.getCityName(cityId)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>

        <Badge style={{ marginTop: 50, padding: 0 }}>
          <div style={{ padding: 24 }}>
            <Typography variant="h6">Başvurular</Typography>
          </div>
          <DataGrid
            disableSelectionOnClick
            autoHeight
            sortingOrder={["desc", "asc"]}
            initialState={{
              sorting: {
                sortModel: [{ field: "TARİH", sort: "asc" }],
              },
            }}
            rows={this.state.rows}
            columns={[
              {
                field: "AD SOYAD",
                flex: 1,
                renderCell: (params) => {
                  return (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {/* <Avatar src={""+params.value.profileURL+""}  /> */}
                      <div style={{ marginLeft: 0 }}>
                        <Typography variant="body1">
                          {params.value.firstName + " " + params.value.lastName}
                        </Typography>
                        <Typography variant="body2">
                          {params.value.email}
                        </Typography>
                      </div>
                    </div>
                  );
                },
              },
              {
                field: "TARİH",
                flex: 1,
                renderCell: (params) => params.row.dateString,
                sortComparator: (v1, v2) => v1 - v2,
              },
              {
                field: "TAMAMLAMA TARİHİ",
                flex: 1,
                renderCell: (params) => params.row.completeDate,
                sortComparator: (v1, v2) => v1 - v2,
              },
              {
                field: "DURUM",
                flex: 1,
                renderCell: (params) => {
                  return (
                    <div
                      style={{
                        paddingTop: 5,
                        paddingBottom: 5,
                        paddingLeft: 10,
                        paddingRight: 10,
                        borderRadius: 20,
                        width: "fit-content",
                        height: "fit-content",
                        backgroundColor: params.value == 0 ? "orange" : "green",
                      }}
                    >
                      <Typography
                        sx={{ color: "white", fontWeight: "700" }}
                        variant="body2"
                      >
                        {(params.value == 0
                          ? "BAŞVURU YAPILIYOR"
                          : "ONAY BEKLİYOR") +
                          " (" +
                          params.row.lFile +
                          "/" +
                          params.row.tFile +
                          ")"}
                      </Typography>
                    </div>
                  );
                },
              },
              { field: "NOT", flex: 1 },
              { field: "TELEFON", flex: 1 },
              { field: "ŞEHİR", flex: 1 },
              { field: "ARAÇ", flex: 1 },
              {
                field: " ",
                renderCell: (params) => {
                  return (
                    <a href={"../application/" + params.row["AD SOYAD"]._id}>
                      <Button>
                        <ArrowForwardIcon />
                      </Button>
                    </a>
                    // or:
                    // <Link to={'/application/' + params.row['AD SOYAD']._id} ><Button><ArrowForwardIcon /></Button></Link>
                  );
                },
              },
            ]}
            pageSize={50}
            rowsPerPageOptions={[50]}
            slotProps={{
              pagination: { showFirstButton: true, showLastButton: true },
            }}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#F3F4F6",
                borderRadius: 0,
              },
            }}
          />
        </Badge>
      </div>
    );
  }
}

var dateFromObjectId = function (objectId) {
  return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
};

const Badge = (props) => {
  return (
    <div
      style={{
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        boxShadow:
          "rgb(100 116 139 / 6%) 0px 1px 1px, rgb(100 116 139 / 10%) 0px 1px 2px",
        borderRadius: 8,
        padding: 24,
        color: "rgb(18, 24, 40)",
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
};
